<template>
  <v-dialog :value="$store.state.system.tryOnShow" class="tryon-dialog" persistent width="400" @input="close">
    <div class="tryon-card">
      <div class="tryon-stage">
        <div id="photo-current" class="tryon-stage__photo">
          <img class="tryon-stage__model" :src="modelImg" alt="Model" />
          <img id="try-img" class="tryon-stage__frame" :style="frameConfig" :src="tryImg" alt="Frame" @load="imgLoad" @error="imgError" />
          <div v-if="loading" class="tryon-stage__loading">
            <div class="tryon-spinner"></div>
          </div>
        </div>
        <div class="tryon-stage__overlay">
          <span class="tryon-stage__badge">VIRTUAL TRY-ON</span>
          <button aria-label="Close" class="tryon-stage__close" @click="close">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M13 5l-8 8M5 5l8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
            </svg>
          </button>
          <p class="tryon-stage__tip">Style reference only · Check Frame Details for size</p>
        </div>
      </div>

      <div class="tryon-pd">
        <span class="tryon-pd__label">PD</span>
        <div class="tryon-pd__wrap">
          <select v-model="selectPd" class="tryon-pd__select" @change="changePd">
            <option v-for="(item, index) in PD" :key="index" :value="item">{{ item }}</option>
          </select>
        </div>
      </div>

      <div class="tryon-gallery">
        <div class="tryon-gallery__track-wrap">
          <button aria-label="Previous" class="tryon-gallery__nav tryon-gallery__nav--prev" @click="move('left', 'model')">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M9 11L5 7l4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>

          <div class="tryon-gallery__viewport">
            <div id="userBox" ref="model" class="tryon-gallery__track" :style="{ transform: `translateX(${modelLeft})` }">
              <div v-for="(item, index) in photolist" :key="item.image_id" class="tryon-gallery__thumb" :class="{ 'tryon-gallery__thumb--active': currentImgIndex === index }" @click="changeModel(index)">
                <img class="tryon-gallery__thumb-img" :src="item.image_path" alt="Model" />
                <button v-if="item.cache || item.online" aria-label="Delete" class="tryon-gallery__thumb-rm" @click.prevent.stop="delModel(item)">
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                    <path d="M8 2L2 8M2 2l6 6" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <button aria-label="Next" class="tryon-gallery__nav tryon-gallery__nav--next" @click="move('right', 'model')">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M5 3l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </div>

        <button class="tryon-gallery__upload" @click="upload">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M7 2.5v9M2.5 7h9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          </svg>
          <span>Upload Your Photo</span>
        </button>
      </div>

      <div v-if="$vuetify.breakpoint.smAndDown" class="tryon-footer">
        <button class="tryon-footer__btn tryon-footer__btn--secondary" @click="close">Close</button>
        <button class="tryon-footer__btn tryon-footer__btn--primary" @click="info">View Details</button>
      </div>
    </div>

    <cropperImg v-if="uploadShow" ref="cropperCom" :config="config" :loading="loading" @close="uploadShow = false" @file="upFile" />
  </v-dialog>
</template>

<script>
import { getBoxInfo, setFrameConfig, getUserPd, setUserPd, getLocalModelCache, delModelItem, saveModeCache } from '@/assets/utils/tryOn'
import { tryData } from '@/components/toolCom/tryOn/mixin/tryConfig'
import cropperImg from '@/components/toolCom/cropperImg'

export default {
  name: 'tryOn',
  components: {
    cropperImg
  },
  mixins: [tryData],
  props: {},
  data() {
    return {
      loading: false,
      uploadShow: false,
      selectPd: '-Select PD-',
      PD: [],
      frameConfig: {
        display: 'block',
        width: undefined,
        height: undefined,
        top: undefined,
        left: undefined,
        transform: undefined
      },
      modelLeft: '0px',
      currentImgIndex: 0,
      config: {
        width: 350,
        height: 400
      }
    }
  },
  computed: {
    tryImg() {
      const img = this.$store.state.system.tryOnImg
      return img
    },
    modelImg() {
      return this.photolist[this.currentImgIndex].image_path
    }
  },
  watch: {},
  mounted() {
    this.PD = this.renderData('-Select PD-', 1, 44, 80)
    this.loading = true
    this.setBoxHeight()
  },
  methods: {
    imgError() {
      this.$tips({ msg: 'Failed to load image.' })
    },
    imgLoad() {
      this.getModelList()
    },
    getModelList() {
      if (!this.$store.state.system.userToken) {
        const list = getLocalModelCache()
        this.photolist.unshift(...list)
        this.concatData(list)
        this.loading = false
        this.changeModel(0)
      } else {
        this.$api.system.getModel().then(res => {
          this.loading = false
          if (res.code === 200) {
            this.concatData(res.data)
            this.changeModel(0)
          }
        })
      }
    },
    concatData(newlist) {
      const oldData = this.$options.data().photolist
      oldData.unshift(...newlist)
      this.photolist = oldData
    },
    setPdSelect() {
      const currentModelInfo = this.photolist[this.currentImgIndex]
      if (currentModelInfo.type) {
        this.selectPd = currentModelInfo.pd
      } else {
        this.selectPd = getUserPd()
      }
    },
    setBoxHeight() {
      const radio = 0.875
      const box = document.querySelector('#photo-current')
      if (!box) {
        return
      }
      const width = box.clientWidth
      const height = width / radio
      box.style.height = height + 'px'
    },
    changePd() {
      const currentPd = this.selectPd
      setUserPd(currentPd)
      setTimeout(() => {
        this.positionFrame(currentPd)
      }, 0)
    },
    changeModel(index) {
      this.currentImgIndex = index
      this.setPdSelect()
      this.positionFrame()
    },
    positionFrame(pd) {
      const currentModelInfo = this.photolist[this.currentImgIndex]
      if (currentModelInfo.type && !pd) {
        pd = currentModelInfo.pd
      } else {
        pd = getUserPd()
      }
      const pxScale = getBoxInfo(currentModelInfo.image_width, currentModelInfo.image_height)
      if (!pxScale) {
        return
      }
      const Lx = currentModelInfo.leftEyeX * pxScale.x
      const Ly = currentModelInfo.leftEyeY * pxScale.y
      const Rx = currentModelInfo.rightEyeX * pxScale.x
      const Ry = currentModelInfo.rightEyeY * pxScale.y
      const img = document.querySelector('#try-img')
      const divWidth = img.naturalWidth
      const divHeight = img.naturalHeight
      const config = setFrameConfig(Lx, Ly, Rx, Ry, 0, 0, divWidth, divHeight, pd, 63, [0, 0])
      this.frameConfig = { ...config }
    },
    upload() {
      this.uploadShow = true
    },
    upFile(file) {
      this.loading = true
      this.$api.system.faceCheckUp(file).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.uploadShow = false
          if (!this.$store.state.system.userToken) {
            saveModeCache(res.data)
          }
          setTimeout(() => {
            this.getModelList()
          }, 0)
        } else {
          this.uploadShow = false
        }
      })
    },
    delModel(item) {
      if (!this.$store.state.system.userToken) {
        delModelItem(item.image_id)
        this.getModelList()
      } else {
        this.loading = true
        this.$api.system.delModel({ image_id: item.image_id }).then(res => {
          if (res.code === 200) {
            this.getModelList()
          }
          this.loading = false
        })
      }
    },
    close() {
      this.$store.commit('system/toggleTryOnShow', { state: false, img: undefined })
    },
    info() {
      this.close()
      const code = this.$store.state.system.tryCode
      this.$route.push({
        name: 'details-code',
        params: { code }
      })
    },
    move(type, dom) {
      let current
      if (dom === 'model') {
        current = parseFloat(this.modelLeft) || 0
      } else {
        current = parseFloat(this.colorLeft) || 0
      }
      const box = document.querySelector('#userBox')
      const maxWidth = box.scrollWidth
      const length = box.childNodes.length
      function step(item) {
        const width = maxWidth / length
        return width * item
      }
      if (type === 'right') {
        if (current <= -maxWidth) {
          return false
        }
        if (dom === 'model') {
          this.modelLeft = current - step(4) + 'px'
        } else {
          this.colorLeft = current - step(4) + 'px'
        }
      } else {
        if (current >= 0) {
          return false
        }
        if (dom === 'model') {
          this.modelLeft = current + step(4) + 'px'
        } else {
          this.colorLeft = current + step(4) + 'px'
        }
      }
    },
    renderData(defaultVla, interval = 0.25, negativeMin = -20, positiveMax = 12) {
      const list = []
      if (negativeMin > 0) {
        list.push(defaultVla)
      }
      for (negativeMin; negativeMin <= positiveMax; negativeMin = negativeMin + interval) {
        if (negativeMin === 0 && defaultVla) {
          list.push(defaultVla)
        } else {
          list.push(negativeMin.toFixed(2))
        }
      }
      return list
    }
  }
}
</script>

<style lang="scss" scoped>
$primary: #3067f2;
$primary-dim: rgba(48, 103, 242, 0.12);
$primary-glow: rgba(48, 103, 242, 0.1);
$text: #1a1a1a;
$text-soft: #6b6b6b;
$text-faint: #999;
$white: #fff;
$cream: #fafaf8;
$border: #e8e5e0;
$border-strong: #d4cfc7;
$shadow-card: 0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.06);
$shadow-elevated: 0 16px 48px rgba(0, 0, 0, 0.14), 0 4px 16px rgba(0, 0, 0, 0.06);
$radius: 14px;
$radius-sm: 10px;
$ease-out: 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);
$ease-spring: 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);

.tryon-dialog {
  ::v-deep .v-dialog {
    border-radius: $radius;
    box-shadow: none;
    overflow: visible;
    margin: 24px auto;
  }

  ::v-deep .v-overlay {
    backdrop-filter: blur(6px);
    background: rgba(18, 18, 20, 0.35);
  }
}

.tryon-card {
  background: $white;
  border-radius: $radius;
  box-shadow: $shadow-elevated;
  overflow: hidden;
  animation: cardIn 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

@keyframes cardIn {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.tryon-stage {
  position: relative;

  &__photo {
    position: relative;
    width: 100%;
    height: 344px;
    overflow: hidden;
    background: #f2f0ed;
  }

  &__model {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  &__frame {
    display: block;
    position: absolute;
    transform-origin: center;
    transition: all $ease-spring;
    pointer-events: none;
    z-index: 2;
  }

  &__loading {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(3px);
    z-index: 3;
  }

  &__overlay {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 12px 14px;
    pointer-events: none;
    z-index: 4;

    > * {
      pointer-events: auto;
    }
  }

  &__badge {
    align-self: flex-start;
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0.08em;
    color: $white;
    background: rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(8px);
    padding: 5px 10px;
    border-radius: 6px;
    text-transform: uppercase;
  }

  &__close {
    align-self: flex-end;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: none;
    background: rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(8px);
    color: $white;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background $ease-out;

    &:hover {
      background: rgba(0, 0, 0, 0.4);
    }
  }

  &__tip {
    align-self: center;
    font-size: 11px;
    color: rgba(255, 255, 255, 0.85);
    margin: 0;
    text-align: center;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  }
}

.tryon-spinner {
  width: 34px;
  height: 34px;
  border: 2.5px solid $primary-dim;
  border-top-color: $primary;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.tryon-pd {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  background: $cream;
  border-bottom: 1px solid $border;

  &__label {
    font-size: 12px;
    font-weight: 600;
    color: $text-soft;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  &__wrap {
    position: relative;
  }

  &__select {
    appearance: none;
    -webkit-appearance: none;
    padding: 6px 28px 6px 12px;
    font-size: 13px;
    font-weight: 500;
    color: $text;
    background: $white;
    border: 1px solid $border-strong;
    border-radius: 7px;
    cursor: pointer;
    outline: none;
    transition: border-color $ease-out, box-shadow $ease-out;
    font-family: inherit;
    background-image: url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%23666' stroke-width='1.2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 10px center;

    &:hover {
      border-color: $primary;
    }

    &:focus {
      border-color: $primary;
      box-shadow: 0 0 0 3px $primary-glow;
    }
  }
}

.tryon-gallery {
  padding: 12px 16px 14px;

  &__track-wrap {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 10px;
  }

  &__nav {
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 1px solid $border;
    background: $white;
    color: $text-soft;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all $ease-out;

    &:hover {
      background: $cream;
      border-color: $border-strong;
      color: $text;
    }

    &:active {
      transform: scale(0.92);
    }
  }

  &__viewport {
    flex: 1;
    overflow: hidden;
  }

  &__track {
    display: flex;
    gap: 8px;
    transition: transform $ease-spring;
  }

  &__thumb {
    position: relative;
    flex-shrink: 0;
    width: 56px;
    height: 56px;
    border-radius: $radius-sm;
    overflow: hidden;
    cursor: pointer;
    transition: transform $ease-out, box-shadow $ease-out;
    box-shadow: 0 0 0 2px transparent;

    &:hover {
      transform: translateY(-2px);
    }

    &--active {
      box-shadow: 0 0 0 2px $primary;
    }
  }

  &__thumb-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  &__thumb-rm {
    position: absolute;
    top: 2px;
    right: 2px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 1.5px solid rgba(255, 255, 255, 0.9);
    background: rgba(0, 0, 0, 0.45);
    backdrop-filter: blur(4px);
    color: $white;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all $ease-out;

    &:hover {
      background: rgba(200, 40, 40, 0.7);
    }
  }

  &__thumb:hover &__thumb-rm {
    opacity: 1;
  }

  &__upload {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 7px 14px;
    font-size: 12px;
    font-weight: 500;
    color: $primary;
    background: $primary-dim;
    border: none;
    border-radius: 20px;
    cursor: pointer;
    transition: background $ease-out, transform $ease-out;
    font-family: inherit;

    &:hover {
      background: rgba(48, 103, 242, 0.18);
    }

    &:active {
      transform: scale(0.97);
    }
  }
}

.tryon-footer {
  display: flex;
  gap: 8px;
  padding: 0 16px 16px;

  &__btn {
    flex: 1;
    padding: 11px 16px;
    font-size: 14px;
    font-weight: 500;
    border-radius: $radius-sm;
    cursor: pointer;
    transition: all $ease-out;
    font-family: inherit;
    border: none;

    &:active {
      transform: scale(0.98);
    }

    &--secondary {
      background: $white;
      color: $text;
      border: 1px solid $border-strong;

      &:hover {
        background: $cream;
      }
    }

    &--primary {
      background: $primary;
      color: $white;

      &:hover {
        background: darken($primary, 5%);
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .tryon-dialog {
    ::v-deep .v-dialog {
      margin: auto;
      border-radius: $radius $radius 0 0;
      width: 100%;
      max-width: 100%;
      height: auto;
      max-height: 90vh;
      max-height: 90dvh;
    }

    ::v-deep .v-overlay {
      backdrop-filter: blur(4px);
      background: rgba(18, 18, 20, 0.4);
    }
  }

  .tryon-card {
    display: flex;
    flex-direction: column;
    border-radius: $radius $radius 0 0;
    animation: cardUp 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  @keyframes cardUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .tryon-stage {
    flex-shrink: 0;

    &__photo {
      height: 300px;
    }

    &__badge {
      font-size: 9px;
      padding: 4px 8px;
    }

    &__tip {
      font-size: 10px;
    }
  }

  .tryon-pd {
    flex-shrink: 0;
  }

  .tryon-gallery {
    flex-shrink: 0;

    &__thumb {
      width: 50px;
      height: 50px;
    }
  }

  .tryon-footer {
    flex-shrink: 0;
  }
}

@media screen and (max-width: 420px) {
  .tryon-stage {
    &__photo {
      height: 260px;
    }
  }

  .tryon-pd {
    padding: 8px 12px;
    gap: 8px;
  }

  .tryon-gallery {
    padding: 10px 12px 12px;

    &__thumb {
      width: 46px;
      height: 46px;
      border-radius: 8px;
    }

    &__nav {
      width: 26px;
      height: 26px;
    }

    &__upload {
      font-size: 11px;
      padding: 6px 12px;
    }
  }

  .tryon-footer {
    padding: 0 12px 12px;

    &__btn {
      font-size: 13px;
      padding: 10px 12px;
    }
  }
}

@media screen and (min-width: 1600px) {
  .tryon-stage {
    &__photo {
      height: 380px;
    }
  }

  .tryon-gallery {
    &__thumb {
      width: 62px;
      height: 62px;
    }
  }
}
</style>
